// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__iWRdk","requiredAsterisk":"Info_requiredAsterisk__2rxcY"};